<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col cols="12" class="py-0">
        <v-row>
          <v-btn text class="grey--text" :to="{ name: 'Order' }">
            <v-icon left>mdi-undo-variant</v-icon>
            {{ $t('btn_txt_back_to_orders') }}
          </v-btn>
        </v-row>
        <v-row class="px-3">
          <span class="primary--text text-h6 text-md-h5">
            {{ $t('cap_order_header_id') }}: {{ orderDetail.documentId }}
          </span>
          <!--            <v-spacer></v-spacer>-->
          <!--            <v-btn outlined large color="primary">{{$t('btn_cap_invoice')}}</v-btn>-->
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <v-card>
              <v-card-title>
                <span class="headline primary--text font-weight-medium">
                  {{ $t('cap_cart_detail') }}
                </span>
              </v-card-title>
              <v-card-subtitle class="pt-2">
                <v-row no-gutters>
                  <v-icon class="primary--text mr-2"
                    >mdi-truck-delivery-outline</v-icon
                  >
                  <span class="black--text text-body-2 text-md-body-1">{{
                    orderDetail.delivery.mode | toTitleCase
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-icon class="primary--text mr-2">mdi-cash-minus</v-icon>
                  <span class="black--text text-body-2 text-md-body-1"
                    >{{ orderDetail.payment.method }} ({{
                      orderDetail.delivery.mode | toTitleCase
                    }})</span
                  >
                </v-row>
              </v-card-subtitle>
              <v-card-text class="py-0">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col sm="6" class="d-flex justify-center">
                        <span>{{ $t('cap_ord_detail_name') }}</span>
                      </v-col>
                      <v-col sm="2">
                        <span>{{ $t('cap_ord_detail_quantity') }}</span>
                      </v-col>
                      <v-col sm="2">
                        <span>{{ $t('cap_ord_detail_price') }}</span>
                      </v-col>
                      <v-col sm="2">
                        <span>{{ $t('cap_ord_detail_total') }}</span>
                      </v-col>
                    </v-row>
                    <v-row class="mt-n4">
                      <v-col cols="12">
                        <v-list
                          max-height="250"
                          class="overflow-y-auto lighten-3 group-item px-2"
                        >
                          <v-row
                            v-for="item in orderDetail.cart"
                            :key="item.id"
                            no-gutters
                            class="mt-1 align-center"
                          >
                            <v-col sm="6">
                              <v-row no-gutters class="align-center">
                                <!--                                <v-col cols="12" sm="2">-->
                                <!--                                  <v-avatar tile :size="$vuetify.breakpoint.mdAndUp? '40' : '30'">-->
                                <!--                                    <v-img :src="image(item.name)" />-->
                                <!--                                  </v-avatar>-->
                                <!--                                </v-col>-->
                                <v-col
                                  cols="12"
                                  sm="10"
                                  class="px-sm-1 px-md-2"
                                >
                                  {{ formatMulti(item.name) }}
                                  <span v-if="item.measureUnit !== 'unit'">
                                    ({{ formatMulti(item.measureUnit) }})
                                  </span>
                                  <span v-if="item.subProduct" class="caption">
                                    +
                                    {{
                                      formatMulti(item.subProduct.name)
                                    }}</span
                                  >
                                  <!--                                    <span v-if="item.subProduct && item.subProduct.measureUnit !== 'Default'"> ({{ formatMulti(item.subProduct.measureUnit) }}) </span>-->
                                  <span
                                    v-if="
                                      item.discount && item.discount.percentage
                                    "
                                    class="red--text caption"
                                  >
                                    ( {{ $t('cap_label_discount') }}
                                    {{ item.discount.percentage }}%)</span
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col sm="2">
                              <span>{{ item.quantity | quantityFormat }}</span>
                            </v-col>
                            <v-col sm="2">
                              <span v-if="item.subProduct">
                                <span v-if="item.discountPrice">
                                  $ {{ +item.price + +item.subProduct.price }}
                                  {{ ' -> ' }}
                                </span>
                                $
                                {{
                                  (item.discountPrice
                                    ? +item.discountPrice +
                                      +item.subProduct.price
                                    : +item.price + +item.subProduct.price)
                                    | numberFormat
                                }}
                              </span>
                              <span v-else>
                                <span v-if="item.discountPrice">
                                  $ {{ item.price }}
                                  {{ ' -> ' }}
                                </span>
                                $
                                {{
                                  (item.discountPrice
                                    ? item.discountPrice
                                    : item.price) | numberFormat
                                }}
                              </span>
                            </v-col>
                            <v-col sm="2">
                              <span v-if="item.subProduct"
                                >$
                                {{
                                  (item.discountPrice
                                    ? (+item.discountPrice +
                                        +item.subProduct.price) *
                                      +item.quantity
                                    : (+item.price + +item.subProduct.price) *
                                      +item.quantity) | numberFormat
                                }}</span
                              >
                              <span v-else
                                >$
                                {{
                                  (item.discountPrice
                                    ? +item.discountPrice * +item.quantity
                                    : +item.price * +item.quantity)
                                    | numberFormat
                                }}</span
                              >
                            </v-col>
                          </v-row>
                        </v-list>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex justify-end" no-gutters>
                      <v-col cols="5" class="mt-n3 pt-0">
                        <v-row>
                          <v-col align="end">
                            <div v-if="orderDetail.subTotal" class="caption">
                              {{ $t('cap_ord_detail_sub_total') }}:
                            </div>
                            <div v-if="orderDetail.vat" class="caption">
                              {{ $t('cap_txt_vad') }}:
                            </div>
                            <div class="primary--text font-weight-bold">
                              {{ $t('cap_ord_detail_total') }}:
                            </div>
                            <div
                              v-if="orderDetail.delivery.fee"
                              class="primary--text font-weight-bold"
                            >
                              {{ $t('cap_delivery_fee') }}:
                            </div>
                          </v-col>
                          <v-col>
                            <div v-if="orderDetail.subTotal">
                              $ {{ orderDetail.subTotal | numberFormat }}
                            </div>
                            <div v-if="orderDetail.vat">
                              $ {{ orderDetail.vat | numberFormat }}
                            </div>
                            <div class="font-weight-bold">
                              $ {{ orderDetail.total | numberFormat }}
                            </div>
                            <div
                              v-if="orderDetail.delivery.fee"
                              class="font-weight-bold"
                            >
                              $ {{ orderDetail.delivery.fee | numberFormat }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="mt-n6 pt-0">
                <v-row class="d-flex justify-end ma-0">
                  <v-col cols="5" class="d-flex justify-center pa-0">
                    <v-checkbox
                      color="primary"
                      :label="$t('btn_txt_paid')"
                      :input-value="orderDetail.payment.paid"
                      :disabled="
                        orderDetail.payment.paid ||
                        orderDetail.status === 'cancel'
                      "
                      @click.self="paidOrder(documentId)"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            v-if="orderDetail.delivery.mode.toLowerCase() !== 'pickup'"
            cols="12"
            md="12"
            class="pt-3"
          >
            <v-card class="pa-2 pb-10">
              <v-form>
                <v-card-title>
                  <span class="headline primary--text font-weight-medium">
                    {{ $t('title_delivery_detail') }}
                  </span>
                </v-card-title>
                <v-card-actions class="py-0 ml-2">
                  <v-row no-gutters>
                    <v-col>
                      <v-row v-if="!orderDetail.delivery.status" no-gutters>
                        <v-col cols="12" class="pt-0">
                          <CassNewDeliveryAgents />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-row no-gutters>
                            <v-col cols="7">
                              <span>{{ $t('cap_delivery_agent') }}</span>
                              <v-select
                                v-model="orderDetail.delivery.name"
                                :items="deliveryAgents"
                                :label="
                                  orderDetail.delivery.status === ''
                                    ? $t('cap_order_detail_choose_delivery')
                                    : 'No Delivery Agent'
                                "
                                chips
                                :single-line="
                                  orderDetail.delivery.status !== ''
                                "
                                :disabled="orderDetail.delivery.status !== ''"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <div v-if="orderDetail.delivery.status">
                            {{ $t('cap_order_header_contact') }}
                          </div>
                          <span v-if="orderDetail.delivery.status">
                            <v-icon class="mr-2">mdi-phone</v-icon>
                            <span>{{
                              orderDetail.delivery.phone | phoneFormat
                            }}</span>
                          </span>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <span>{{ $t('cap_delivery_status') }}</span>
                          <v-checkbox
                            :label="$t('cap_delivery_status_placed')"
                            class="ma-0 pa-0"
                            :input-value="orderDetail.delivery.status !== ''"
                            :disabled="orderDetail.delivery.status !== ''"
                            @click.self="placeDelivery(documentId)"
                          >
                          </v-checkbox>
                          <v-checkbox
                            :label="$t('cap_delivery_status_done')"
                            class="mt-n4 pa-0"
                            :input-value="
                              orderDetail.delivery.status === 'done'
                            "
                            :disabled="
                              orderDetail.delivery.status !== 'delivering'
                            "
                            @click.self="delivered(documentId)"
                          >
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title class="primary--text">
              {{ $t('title_quick_info') }}
              <v-spacer></v-spacer>
              <CassAssignBranch
                v-if="orderDetail.status === 'newOrder'"
                :document-id="documentId"
              ></CassAssignBranch>
            </v-card-title>
            <v-card-text>
              <div class="black--text">
                Date: {{ orderDetail.timestamp.toDate() | dateFormat }}
              </div>
              <div
                v-if="orderDetail.branch"
                class="black--text"
                v-html="$t('cap_txt_bus_branch', { value: orderDetail.branch })"
              ></div>
              <div
                v-show="
                  orderDetail.delivery.status !== 'done' &&
                  orderDetail.status !== 'cancel'
                "
                class="red--text"
              >
                {{ $t('cap_instruct_next') }}
              </div>
              <!--Cancel Info -->
              <div v-if="orderDetail.status === 'cancel'" class="error--text">
                {{ $t('cap_txt_reason') }}:
                {{ orderDetail.cancel.reason | toTitleCase }}
              </div>
              <div
                v-if="
                  orderDetail.status === 'cancel' && orderDetail.cancel.desc
                "
                class="error--text"
              >
                {{ $t('cap_form_create_prod_desc') }}:
                {{ orderDetail.cancel.desc }}
              </div>
              <v-row no-gutters>
                <v-col
                  v-if="
                    orderDetail.delivery.mode === 'delivery' &&
                    orderDetail.status === 'newOrder'
                  "
                  cols="12"
                >
                  <v-text-field
                    v-model="fee"
                    :label="$t('cap_delivery_fee')"
                    prefix="$"
                    :rules="deliveryFee"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-checkbox
                v-if="orderDetail.status === 'newOrder'"
                :label="$t('cap_order_header_processing')"
                class="ma-0 ml-4"
                :input-value="orderDetail.status === 'processing'"
                :disabled="orderDetail.status === 'cancel'"
                @click.self="
                  processOrder(documentId, orderDetail.delivery.name)
                "
              >
              </v-checkbox>
              <v-checkbox
                v-else-if="
                  (orderDetail.status === 'processing') &
                  (orderDetail.delivery.status === '')
                "
                :label="
                  orderDetail.delivery.mode.toLowerCase() !== 'pickup'
                    ? $t('cap_delivery_status_placed')
                    : $t('cap_pickup_status_placed')
                "
                class="ma-0 ml-4"
                :input-value="orderDetail.delivery.status === 'delivering'"
                :disabled="orderDetail.status === 'cancel'"
                @click.self="placeDelivery(documentId)"
              >
              </v-checkbox>
              <v-checkbox
                v-else-if="
                  (orderDetail.status === 'processing') &
                  (orderDetail.delivery.status === 'delivering')
                "
                :label="
                  orderDetail.delivery.mode.toLowerCase() !== 'pickup'
                    ? $t('cap_delivery_status_done')
                    : $t('cap_order_header_done')
                "
                class="ma-0 ml-4"
                :input-value="orderDetail.delivery.status === 'done'"
                :disabled="orderDetail.status === 'cancel'"
                @click.self="delivered(documentId)"
              >
              </v-checkbox>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pt-3">
          <v-card class="mx-auto">
            <v-card-title class="primary--text">
              <span>{{ $t('title_cus_detail') }}</span>
              <v-spacer></v-spacer>
              <CassEditCustomerInfo
                :document-id="documentId"
              ></CassEditCustomerInfo>

              <!--              <v-dialog v-model="dialog" persistent max-width="600px">-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-btn color="primary" dark v-bind="attrs" v-on="on">-->
              <!--                    Edit-->
              <!--                  </v-btn>-->
              <!--                </template>-->
              <!--                <v-card>-->
              <!--                  <v-card-title>-->
              <!--                    <span class="headline">Customer Profile Editor</span>-->
              <!--                  </v-card-title>-->
              <!--                  <v-card-text>-->
              <!--                    <v-container>-->
              <!--                      <v-row>-->
              <!--                        <v-col-->
              <!--                          v-if="-->
              <!--                            orderDetail.customer.hasOwnProperty('location') &&-->
              <!--                            orderDetail.customer.location.hasOwnProperty(-->
              <!--                              'address'-->
              <!--                            ) &&-->
              <!--                            orderDetail.customer.location.address-->
              <!--                          "-->
              <!--                          cols="12"-->
              <!--                          sm="6"-->
              <!--                        >-->
              <!--                          <v-text-field-->
              <!--                            v-model="orderDetail.customer.location.address"-->
              <!--                            label="Location*"-->
              <!--                            :rules="locationRules"-->
              <!--                            prepend-icon="mdi-map-marker"-->
              <!--                          ></v-text-field>-->
              <!--                        </v-col>-->
              <!--                        <v-col cols="12">-->
              <!--                          <v-text-field-->
              <!--                            v-model="orderDetail.customer.note"-->
              <!--                            label="Note*"-->
              <!--                            :rules="noteRules"-->
              <!--                            prepend-icon="mdi-square-edit-outline"-->
              <!--                          ></v-text-field>-->
              <!--                        </v-col>-->
              <!--                      </v-row>-->
              <!--                    </v-container>-->
              <!--                  </v-card-text>-->
              <!--                  <v-card-actions>-->
              <!--                    <v-spacer></v-spacer>-->
              <!--                    <v-btn color="blue darken-1" text @click="dialog = false">-->
              <!--                      Close-->
              <!--                    </v-btn>-->
              <!--                    <v-btn color="blue darken-1" text @click="updateCustomer">-->
              <!--                      Save-->
              <!--                    </v-btn>-->
              <!--                  </v-card-actions>-->
              <!--                </v-card>-->
              <!--              </v-dialog>-->
            </v-card-title>
            <v-card-text class="pt-0">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3" class="justify-center d-flex">
                      <v-icon large class="blue--text"
                        >mdi-facebook-messenger</v-icon
                      >
                    </v-col>
                    <v-col sm="9" class="ml-n16 ml-md-n3">
                      <span class="black--text">{{
                        orderDetail.customer.name
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3" class="justify-center d-flex">
                      <v-icon class="grey--text">mdi-phone</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n16 ml-md-n3">
                      <span class="black--text">{{
                        orderDetail.customer.phone
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      orderDetail.customer.hasOwnProperty('location') &&
                      orderDetail.customer.location.hasOwnProperty('address') &&
                      orderDetail.customer.location.address
                    "
                    align="start"
                    class="mt-n3"
                  >
                    <v-col sm="3" class="justify-center d-flex">
                      <v-icon class="grey--text">mdi-map-marker</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="black--text">{{
                        orderDetail.customer.location.address
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3" class="justify-center d-flex">
                      <v-icon class="grey--text"
                        >mdi-square-edit-outline</v-icon
                      >
                    </v-col>
                    <v-col sm="9" class="ml-n16 ml-md-n3">
                      <span class="grey--text font-italic">{{
                        noteFormat(orderDetail.customer.note)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      orderDetail.payment.method == 'Cash' &&
                      orderDetail.payment.hasOwnProperty('cash') &&
                      orderDetail.delivery.mode == 'delivery'
                    "
                    align="center"
                    class="mt-n3"
                  >
                    <v-col sm="3" class="justify-center d-flex">
                      <v-icon class="grey--text">mdi-cash-minus</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n16 ml-md-n3">
                      <span class="grey--text font-italic">{{
                        noteFormat(orderDetail.payment.cash)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="d-flex justify-center">
                    <v-col
                      v-if="
                        orderDetail.customer.hasOwnProperty('location') &&
                        orderDetail.customer.location.hasOwnProperty('cord') &&
                        orderDetail.delivery.mode == 'delivery'
                      "
                      cols="12"
                      sm="11"
                      md="12"
                    >
                      <v-row align="center" class="mt-n3">
                        <v-col sm="3" class="justify-center d-flex">
                          <CassQRcode :document-id="documentId"></CassQRcode>
                        </v-col>
                        <v-col sm="3" class="ml-1">
                          <CassMapping :document-id="documentId"></CassMapping>
                        </v-col>
                      </v-row>
                      <!-- Customer Map -->
                      <!--                      <div id="map" class="google-map"></div>-->
                      <!--                      <v-row align="center" class="mt-n3">-->
                      <!--                        <v-col sm="3" class="justify-center d-flex">-->
                      <!--                          <CassQRcode :document-id="documentId"></CassQRcode>-->
                      <!--                        </v-col>-->
                      <!--                        <v-col sm="3" class="ml-1">-->
                      <!--                          <CassMapping :document-id="documentId"></CassMapping>-->
                      <!--                        </v-col>-->
                      <!--                      </v-row>-->
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          v-if="
            orderDetail.status !== 'done' && orderDetail.status !== 'cancel'
          "
          cols="12"
          class="pt-0"
        >
          <CassOrderCancel :document-id="documentId" />
        </v-col>
      </v-col>
      <v-snackbar v-model="snackbar" :timeout="2000">
        {{ notification }}
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
            {{ $t('btn_txt_cancel') }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
import CassNewDeliveryAgents from '../dialogs/CassNewDeliveryAgents'
import CassOrderCancel from '../dialogs/CassOrderCancel'
import CassEditCustomerInfo from '../dialogs/CassEditCustomerInfo'
import CassQRcode from '../dialogs/CassQRcode'
import CassMapping from '../dialogs/CassMapping'
import CassAssignBranch from '../dialogs/CassAssignBranch'

// /* global google */
export default {
  name: 'CassOrderDetail',
  components: {
    CassMapping,
    CassQRcode,
    CassEditCustomerInfo,
    CassNewDeliveryAgents,
    CassOrderCancel,
    CassAssignBranch
  },
  filters: {
    dateFormat(data) {
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }
      return new Intl.DateTimeFormat('en-GB', options).format(data)
    },
    phoneFormat(data) {
      return data || 'Not Available'
    },
    numberFormat(data) {
      return (Math.round(data * 100) / 100).toFixed(2)
    },
    toTitleCase(str) {
      return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()
    },
    quantityFormat(data) {
      return data > 9 ? data : '0' + data
    }
  },
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      snackbar: false,
      notification: '',
      dialog: false,
      fee: ''
    }
  },
  computed: {
    documentId() {
      return this.$route.params.order_id
    },
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    },
    deliveryAgents() {
      return this.$store.state.deliveryAgent.deliveryAgents.map((agent) => {
        return agent.name
      })
    },
    locationRules() {
      return [(v) => !!v || 'Location is required']
    },
    noteRules() {
      return [(v) => !!v || 'Note is required']
    },
    deliveryFee() {
      return [
        // (v) =>
        //   (!isNaN(parseFloat(v)) && v > 0) || 'Price must be bigger than 10'
        (v) => v >= 0 || this.$t('cap_form_price_invalid')
      ]
    }
  },
  mounted() {
    // this.initMap()
  },
  methods: {
    initMap() {
      // if (Object.prototype.hasOwnProperty.call(this.orderDetail.customer, 'location') &&
      //     Object.prototype.hasOwnProperty.call(this.orderDetail.customer.location, 'cord')) {
      //   const location = { lat: this.orderDetail.customer.location.cord.latitude, lng: this.orderDetail.customer.location.cord.longitude }
      //   const map = new google.maps.Map(document.getElementById('map'), {
      //     center: location,
      //     zoom: 13,
      //     maxZoom: 16,
      //     minZoom: 10,
      //     disableDefaultUI: true
      //   })
      //   const marker = new google.maps.Marker({ position: location, map })
      //   marker.addListener('click', () => {
      //     if (marker.getAnimation() !== null) {
      //       marker.setAnimation(null)
      //     } else {
      //       marker.setAnimation(google.maps.Animation.BOUNCE)
      //       setTimeout(() => marker.setAnimation(null), 2000)
      //     }
      //   })
      // }
    },
    processOrder(documentId, name) {
      if (confirm(this.$t('txt_confirm_1'))) {
        const phone = this.deliveryPhone(name)
        const payload = {
          documentId,
          delivery: { name, phone, fee: (this.fee = parseFloat(this.fee)) }
        }
        this.notification = this.$t('cap_txt_noti_msg_04')
        this.snackbar = true
        this.$store.dispatch('order/processOrder', payload)
      }
    },
    placeDelivery(documentId) {
      if (confirm(this.$t('txt_confirm_2'))) {
        const payload = { documentId }
        this.notification = this.$t('cap_txt_noti_msg_05')
        this.snackbar = true
        this.$store.dispatch('order/processDelivery', payload)
      }
    },
    delivered(documentId) {
      if (confirm(this.$t('txt_confirm_3'))) {
        const payload = { documentId }
        this.notification = this.$t('cap_txt_noti_msg_06')
        this.snackbar = true
        this.$store.dispatch('order/closingOrder', payload)
      }
    },
    paidOrder(documentId) {
      if (confirm(this.$t('txt_confirm_4'))) {
        const payload = { documentId }
        this.notification = this.$t('cap_txt_noti_msg_07')
        this.snackbar = true
        this.$store.dispatch('order/paidOrder', payload)
      }
    },
    // image (value) {
    //   let image = ''
    //   this.$store.getters['product/productAfterFilter'].forEach(product => {
    //     if (product.name === value) {
    //       image = product.image
    //     }
    //   })
    //   return image
    // },
    deliveryPhone(name) {
      let phone = ''
      this.$store.state.deliveryAgent.deliveryAgents.forEach((agent) => {
        if (agent.name === name) {
          phone = agent.phone
        }
      })
      return phone
    },
    formatMulti(value) {
      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale]
        } else {
          return value.en
        }
      } else {
        return value
      }
    },
    noteFormat(data) {
      return data || this.$t('cap_no_note')
    }
  }
}
</script>
<style scoped>
/*.google-map {*/
/*  width: 100%;*/
/*  height: 200px;*/
/*  background-color: grey;*/
/*}*/
</style>
